import { doMutation } from "../../core-module/util/graphqlHelper";
import { apolloClient } from "@/plugins/vue-apollo";

const updateGetEmployeesCache = ({ employee, variables }) => {
  try {
    if (employee) {
      const cacheKey = {
        query: require("../api/query/getEmployees.gql"),
        variables: variables,
      };

      const cachedData = apolloClient.readQuery(cacheKey);

      if (cachedData?.getEmployees) {
        const existingEmployeeIndex =
          cachedData.getEmployees.employees.findIndex(
            x => x._id === employee._id
          );

        if (existingEmployeeIndex >= 0) {
          cachedData.getEmployees.employees.splice(existingEmployeeIndex, 1);
        }

        apolloClient.writeQuery({ ...cacheKey, data: cachedData });
      }
    }
  } catch (e) {
    console.log("deleteEmployee.updateGetEmployeesCache:exception:", e.message);
  }
};

export const deleteEmployee = id => {
  const mutation = require("../api/mutation/deleteEmployee.gql");
  const variables = {
    id: id,
  };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) {
      updateGetEmployeesCache({
        employee: data.deleteEmployee,
        variables: { limit: 0, skip: 0 },
      });
      return { data: data.deleteEmployee };
    } else if (error) return { error: JSON.stringify(error) };
  });
};
